<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M0.157714 9.4924C0.157715 10.0369 0.599144 10.4784 1.14367 10.4784L7.5524 10.4784L7.5524 16.8871C7.5524 17.4316 7.99383 17.873 8.53836 17.873L9.52432 17.873C10.0688 17.873 10.5103 17.4316 10.5103 16.8871L10.5103 10.4784L16.919 10.4784C17.4635 10.4784 17.905 10.0369 17.905 9.4924L17.905 8.50644C17.905 7.96191 17.4635 7.52049 16.919 7.52049L10.5103 7.52049L10.5103 1.11176C10.5103 0.567222 10.0688 0.125801 9.52432 0.125801L8.53836 0.125801C7.99383 0.125801 7.5524 0.567222 7.5524 1.11176L7.5524 7.52049L1.14367 7.52049C0.599143 7.52049 0.157714 7.96191 0.157714 8.50644L0.157714 9.4924Z"
    />
  </svg>
</template>
